var _desc, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "13px",
    viewBox: "0 0 15 13",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.53896C14.4422 1.8 13.8478 1.97299 13.2281 2.05695C13.8656 1.65097 14.3522 1.01294 14.581 0.243951C13.9865 0.62198 13.3303 0.888972 12.6309 1.03794C12.0666 0.396964 11.2622 0 10.3847 0C8.68221 0 7.31154 1.47394 7.31154 3.28099C7.31154 3.541 7.33216 3.79095 7.38283 4.02902C4.82626 3.89599 2.56405 2.58897 1.04442 0.59802C0.77906 1.08893 0.62349 1.65097 0.62349 2.25598C0.62349 3.39197 1.17189 4.39896 1.98939 4.98203C1.49533 4.97198 1.01064 4.81897 0.599993 4.57802L0.599993 4.61399C0.599993 6.20798 1.66595 7.53203 3.06379 7.83695C2.81343 7.91 2.54066 7.94499 2.2575 7.94499C2.06062 7.94499 1.86191 7.93304 1.67532 7.88898C2.07378 9.18797 3.20437 10.143 4.54878 10.174C3.50253 11.047 2.17408 11.573 0.735974 11.573C0.483775 11.573 0.241859 11.5611 0 11.528C1.36216 12.465 2.97658 13 4.71751 13C10.3763 13 13.47 8.00001 13.47 3.66601C13.47 3.52102 13.4653 3.381 13.4588 3.24196C14.069 2.77998 14.5819 2.20297 15 1.53896",
    id: "tw",
    fill: "#FFFFFF",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTwitter);
export default __webpack_public_path__ + "static/media/ico-twitter.b888064bad60b559fcd4604aeaa56a12.svg";
export { ForwardRef as ReactComponent };